import React, {useContext} from 'react';
import Navbar from "react-bootstrap/Navbar";
import {Link} from "react-router-dom";
import logo from "../../../assets/images/logo-white.svg";
import NavDropdown from "react-bootstrap/NavDropdown";
import {FaHome, FaUserCircle} from "react-icons/fa";
import {MortgageContext} from "../../contexts/MortgageProvider";
function SussdBarMobile(props) {
    const mortgageContext = useContext(MortgageContext)
    return (
        <>
            <div>


                    <Navbar bg="light" className="py-0 bg-primary" id={'top-element'}>
                        <div className="container-lg">
                            <div className="d-flex align-items-end justify-content-between text-white w-100">
                                {
                                    !props?.hamburgerHidden && (
                                        <div className={`d-md-none hamburger text-white ${props.sidebarOpen ? 'open':''}`} onClick={props.toggleSidebar}>
                                            <span></span>
                                            <span></span>
                                            <span></span>
                                        </div>
                                    )
                                }
                                <Link to={'/'} className="d-none d-md-inline">
                                    <FaHome size={36} color={"white"}/>
                                </Link>

                                <Navbar.Brand as={Link} to="/" className="m-0">
                                    <img alt="Company Logo" src={logo} style={{height:'42px'}}/>
                                </Navbar.Brand>


                                <NavDropdown title={<FaUserCircle size={36} color={"white"}/>} align="end" className="user-btn no-caret font-alt">
                                    <NavDropdown.Header className="small">{mortgageContext.mortgage.applicant1.email}</NavDropdown.Header>
                                    <NavDropdown.Divider/>
                                    <NavDropdown.Item onClick={props.signOut} className="px-3">Sign Out</NavDropdown.Item>
                                </NavDropdown>
                            </div>
                        </div>
                    </Navbar>
                {/*<img src={mobileHeader} style={{width:'100%'}}/>*/}
                {/*<div style={{height:'100px', backgroundRepeat:'no-repeat', backgroundSize: '100% auto', backgroundImage: `url(${primaryCurve})`}}>*/}
                <div className="position-relative pb-3" style={{marginTop:'-1px'}}>
                    <svg xmlns="http://www.w3.org/2000/svg" height="50" width="100%" preserveAspectRatio="none" viewBox="0 0 407 79.468" style={{ transform: 'scaleX(-1)'}}>
                        <g id="primary-curve" transform="translate(0 0)">
                            <path id="Path_1" data-name="Path 1" d="M-69.986-169.67h407V-90.2s-89.355-60.605-219.321-72.431C-11.79-174.415-69.986-133.67-69.986-133.67Z" transform="translate(69.986 169.67)" fill="#0083c1"/>
                        </g>
                    </svg>
                    <div className="position-absolute font-alt w-100 text-center text-primary bold pt-4 pt-sm-3 top-0" >MORTGAGE APPLICATION</div>
                </div>


                {/*</div>*/}
            </div>


        </>)
}

export default SussdBarMobile;